const CATEGORY_LABELS = {
  JP: {
    Cafe: "カフェ",
    Gourmet: "グルメ",
    Dinner: "夜ご飯",
    Drive: "ドライブ",
    Tour: "ツアー",
    Shooting: "撮影",
    Beach: "ビーチ",
    "Rainy Day": "雨の日",
    Sunset: "サンセット",
    Spot: "スポット",
    Night: "夜遊び",
    Star: "星空",
    Shisha: "シーシャ",
    "Girls Trip": "女子旅",
  },
  EN: {
    Cafe: "Cafe",
    Gourmet: "Gourmet",
    Dinner: "Dinner",
    Drive: "Drive",
    Tour: "Tour",
    Shooting: "Shooting",
    Beach: "Beach",
    "Rainy Day": "Rainy Day",
    Sunset: "Sunset",
    Spot: "Spot",
    Night: "Night",
    Star: "Star",
    Shisha: "Shisha",
    "Girls Trip": "Girls Trip",
  },
  中文: {
    Cafe: "咖啡",
    Gourmet: "美食",
    Dinner: "晚餐",
    Drive: "自驾",
    Tour: "体验",
    Shooting: "拍摄",
    Beach: "海滩",
    "Rainy Day": "雨天",
    Sunset: "日落",
    Spot: "景点",
    Night: "夜游",
    Star: "星空",
    Shisha: "水烟",
    "Girls Trip": "女生旅行",
  },
  한국어: {
    Cafe: "카페",
    Gourmet: "맛집",
    Dinner: "저녁식사",
    Drive: "드라이브",
    Tour: "투어",
    Shooting: "촬영",
    Beach: "비치",
    "Rainy Day": "비 오는 날",
    Sunset: "선셋",
    Spot: "스팟",
    Night: "나이트",
    Star: "별하늘",
    Shisha: "시샤",
    "Girls Trip": "여자여행",
  },
};

export const getBlogCategoryLabel = (category, lang = "JP") => {
  return (
    CATEGORY_LABELS[lang]?.[category] ||
    CATEGORY_LABELS.JP[category] ||
    category
  );
};
